import Layout from "../../components/layOutWrapper/layOutWrapper";
import ShowMyExpenseReportRequests from "../../components/expenseReportRequests/showMyExpenseReportRequests";

export default function ShowMyExpenseReportRequestsView () {
    return (
        <>
            <Layout children={<ShowMyExpenseReportRequests/>} sectionTitle="Mis solicitudes de rendición de gastos"/>
        </>
    )
}